import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Graphic = ({ listGraphic }) => {
    return (
        <div className="otpBank-graphic">
            <FullWrapper className="otpBank-graphicCase">
                <div className="otpBank-graphicWrapper">
                    <div className="otpBank-graphicContainer">
                        <div className="otpBank-graphicItems">
                            {listGraphic.map((item, index) => (
                                <div className="otpBank-graphicItem" key={index}>
                                    <div className="otpBank-graphicBlock">
                                        <div className="otpBank-graphicNumber">{item.number}</div>
                                        <div
                                            className="otpBank-graphicText"
                                            dangerouslySetInnerHTML={{ __html: item.text }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="otpBank-graphicStart">сентябрь 2021</div>
                    <div className="otpBank-graphicEnd">декабрь 2022</div>
                    {/*<div className="otpBank-graphicBottom">*/}
                    {/*    <div className="otpBank-graphicTimeLine">*/}
                    {/*        <div className="otpBank-graphicStart">сентябрь 2021</div>*/}
                    {/*        <div className="otpBank-graphicEnd">декабрь 2022</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </FullWrapper>
        </div>
    );
};

export default Graphic;
